import { Form, Formik } from "formik";
import * as Yup from "yup";
import Button from "../../../shared/ui/Button";
import FormikLabeledInput from "../../../shared/ui/Form/FormikLabeledInput";
import LabeledFormikSelect from "../../../shared/ui/Form/LabeledFormikSelect";

const paymentStatusOptions = [
    { label: "PAID", value: "PAID" },
    { label: "PENDING", value: "PENDING" },
    { label: "CANCELLED", value: "CANCELLED" },
];

const validationSchema = Yup.object().shape({
    paymentReceived: Yup.string().required("Amount is required"),
    paymentStatus: Yup.string().required("Status is required"),
});

const PaymentForm = (handleApprove, amount, status) => {
    const handleSubmit = (values) => {
        handleApprove(values);
    };

    return (
        <Formik
            initialValues={{
                paymentReceived: amount,
                paymentStatus: status,
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {() => (
                <Form className="p-1 mb-2">
                    <FormikLabeledInput
                        label="Payment Received"
                        name="paymentReceived"
                        required
                    />

                    <LabeledFormikSelect
                        name="paymentStatus"
                        label="Payment Status"
                        options={paymentStatusOptions}
                        required
                    />

                    <Button type="submit">Update Payment</Button>
                </Form>
            )}
        </Formik>
    );
};

export default PaymentForm;
